(() => {
  const initializeJournal = (root) => {
    if (!root || root.dataset.thJournalInitialized === 'true') return;
    root.dataset.thJournalInitialized = 'true';

    const revealItems = root.querySelectorAll('.th-journal__reveal');
    const animationsEnabled = root.dataset.animations === 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!animationsEnabled || reducedMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -50px 0px' }
    );

    revealItems.forEach((item, index) => {
      item.style.transitionDelay = `${Math.min(index % 3, 2) * 90}ms`;
      observer.observe(item);
    });
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-th-journal-native]').forEach(initializeJournal);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
